import {createAction, props} from '@ngrx/store';
import {Torneo} from '../../../../core/@types';
import {TorneiListFiltriState} from '../reducers/tornei-list.reducer';

export const LoadListData = createAction(
  '[Tornei][List] Load List Data',
  props<{ data?: string }>()
);

export const LoadListDataSuccess = createAction(
  '[Tornei][List] Load List Data Success',
  props<{ list: Torneo[] }>()
);

export const LoadListDataError = createAction(
  '[Tornei][List] Load List Data Error',
  props<{ error: any }>()
);

export const SetFilters = createAction(
  '[Tornei][List] Set Filters',
  props<{ filters: TorneiListFiltriState }>()
);
